module.exports = {
    projectName: "__PROJECT_NAME__",
    operatorEmail: "__OPERATOR_EMAIL_",

    apiBase:"__MASTER_URL__/api/",
    frontendBase:"__MASTER_URL__/",

    publicToken: "__PUBLIC_TOKEN__",
    ssrToken: "__SSR_TOKEN__",

    ssrValidatePath: function(path) {
        // TODO validate if path ssr rendering is ok, -1 = NOTFOUND, 0 = NO SSR, 1 = SSR
        // pe. use context.readCollection("product", {filter: {path: path}}) ... to validate dynamic urls
        
        return path.match(/^\/(home|service)\/?$/)
    }
}
